<template>
    <form @submit.prevent="$emit('submit')" class="space-y-6">
        <FormSection>
            <template #title>
                Pathway Information
            </template>

            <FormGroup
                name="name"
                label="Name">
                <Input
                    ref="name"
                    v-model="form.name"
                    name="name"
                    placeholder="Please enter the name..."/>
            </FormGroup>

            <template v-if="$slots.footer" #footer>
                <slot name="footer"></slot>
            </template>
        </FormSection>
    </form>
</template>

<script>

import FormSection from "@/Components/Form/FormSection.vue";
import FormGroup from "@/Components/Form/FormGroup.vue";
import Input from "@/Components/Form/Input.vue";

export default {

    name: "PathwayForm",

    emits: ['submit'],

    inject: ['form'],

    mounted() {
        this.$nextTick(() => {
            this.$refs.name.mainElement().focus()
        });
    },

    components: {
        FormSection,
        FormGroup,
        Input,
    }
};

</script>
